var defaultTexts = {
    title: 'Введите код из\xa0сообщения',
    codeError: 'Код введён неверно',
    codeChecking: '',
    codeSending: '',
    buttonRetry: 'Запросить код повторно',
    linkToHint: 'Не\xa0приходит сообщение?',
    hintButton: 'Вернуться к\xa0вводу кода',
    noAttemptsLeft: 'Не\xa0осталось попыток запроса кода',
    fatalErrorTitle: 'Ввести код больше нельзя',
    fatalErrorDescription: 'Вы\xa0ввели код неверно более 5\xa0раз. В\xa0целях безопасности мы\xa0ограничили дальнейший ввод.',
    fatalErrorButton: 'Понятно',
    tempBlockTitle: 'Превышено количество попыток запроса кода',
    tempBlockDescription: 'Повторное подтверждение кодом будет возможно через 24\xa0часа',
    codeSended: 'Код выслан',
    countdown: 'Запросить повторно можно через',
    domesticPhone: '8 800 200 00 00',
    internationalPhone: '+7 495 78 888 78',
};

export { defaultTexts };
